import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
        Pragma: "no-cache",
      },
    };
  }

  static getDocumentations(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/documentations/list", requestData, this.requestConfig());
  }

  static createDocumentation(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/documentations/create", requestData, this.requestConfig());
  }

  static updateDocumentation(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/documentations/update", requestData, this.requestConfig());
  }

  static deleteDocumentation(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/documentations/delete", requestData, this.requestConfig());
  }

  static uploadFile(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/documentations/upload", requestData, this.requestConfig());
  }
}

export default Service;
